module.exports = __webpack_public_path__ + "img/ic_alarm_small_line.94998d15.svg";